<template>
  <div class="activity">
    <div class="banner">
      <img class="banner-img" :src="poster" alt="" />
      <div class="banner-content">
        <h2>{{ name }}</h2>
        <h2 class="status ing" v-if="TENANTID == 59">『摄影赛道』</h2>
        <div class="act-infos">
          <div v-if="type == 0" class="status ing">进行中</div>
          <div v-if="type == 1" class="status red">已结束</div>
          <div v-if="type == 2" class="status end">未开始</div>
          <div class="act-infos-lst">
            <div
              :class="['lst-item', item.lnkFn ? 'link' : '']"
              v-for="(item, i) in infosList"
              :key="i"
            >
              <img v-if="!item.lnkFn" :src="item.ico" alt="" />
              <!-- <p v-if="item.lnkFn" @click="tagetFn(item.lnkFn)">
                {{ item.txt }}
              </p> -->
              <p>{{ item.txt }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="affairsQuery" v-if="TENANTID != 59" @click="getaffairsQuery">
      <van-image width="100%" height="100%" :src="Queryicon" />
    </div>
    <div class="act-attention">
      <div :class="TENANTID == 59?'act-intro2':'act-intro'">
        <sign-title title="活动介绍" :simplicity="true" />
        <div class="intro-txt" v-if="TENANTID == 59" v-html="intro2"></div>
        <div class="intro-txt" v-else v-html="intro"></div>
      </div>
    </div>
    <van-popup
      v-model="unitShow"
      closeable
      close-icon="arrow-down"
      close-icon-position="top-right"
      position="bottom"
      :style="{ height: '50%' }"
    >
      <div class="unit-lst-wrap">
        <div class="unit-lst" v-html="unitList"></div>
      </div>
    </van-popup>
    <div class="contribute" @click="toApplyPage" v-if="role === 0">
      <van-button
        size="large"
        color="linear-gradient(to right, #5DD682, #5AFF8E)"
        >我要投稿</van-button
      >
    </div>
  </div>
</template>

<script>
import SignTitle from "@/components/pub/SignTitle.vue";
import { activityDetail } from "@/utils/api/home";
import { localStorageGetItem } from "@/utils/auth";
export default {
  components: {
    "sign-title": SignTitle
  },
  data() {
    return {
      Queryicon: require("@/assets/images/active/botton_zixun.png"),
      // 角色
      role: 0,
      // 活动简介
      intro: ``,
      // 活动流程日期
      infosList: [],
      // 单位显示
      unitShow: false,
      // 单位列表
      unitList: ``,
      // 活动名称
      name: "",
      // 互动海报
      poster: null,
      // 活动状态
      type: 0,
      activityId: this.$route.query.activityId,
      TENANTID:0,
      intro2:`<p><br></p><p style="text-align: center;"><strong>第二十八届全国中小学生绘画书法作品比赛</strong></p><p style="text-align: center;"><strong>摄影赛道</strong></p><p style="text-indent: 32pt;"><span style="font-family: 仿宋;"> </span></p><p style="text-indent: 32pt;"><span style="font-family: 黑体;">一、比赛主题：</span><span style="font-family: 仿宋;">我的梦想</span></p><p style="text-indent: 32pt; text-align: left;"><span style="font-family: 黑体;">二、组织机构</span></p><p style="text-indent: 32pt; text-align: left;"><span style="font-family: 仿宋;">主办单位：中国儿童中心</span></p><p style="text-indent: 32pt; text-align: left;"><span style="font-family: 仿宋;">承办单位：《中国校外教育》杂志社有限公司</span></p><p style="text-indent: 32pt;"><span style="font-family: 仿宋;">摄影赛道支持单位：北京故事文化科技有限公司</span></p><p style="text-indent: 32pt; text-align: left;"><span style="font-family: 黑体;">三、作品类型</span></p><p style="text-indent: 32pt;"><span style="font-family: 仿宋;">包括绘画（含漫画、绘本）、书法（含篆刻、硬笔）、 </span><u><strong>摄影</strong></u><span style="font-family: 仿宋;">、设计艺术（含数字美术、服装设计）、造型艺术（含雕塑、陶艺）。</span></p><p style="text-indent: 32pt;"><span style="font-family: 黑体;">四、参赛组别 </span></p><p style="text-indent: 32pt;"><span style="font-family: 仿宋;">参赛对象：全国中小学生</span></p><p style="text-indent: 32pt;"><span style="font-family: 仿宋;">组别：小学低年级组（1-3年级）、小学高年级组（4-6年级）、初中组、高中组（含职高）。</span></p><p style="text-indent: 32pt;"><span style="font-family: 仿宋;">小学为5年制的地区，初中预备班可自行选择小学高年级组或初中组。集体创作作品以最大参赛学生年龄认定为对应组别。</span></p><p style="text-indent: 32pt;"><span style="font-family: 黑体;">五、</span><span style="font-family: 仿宋;"> </span><strong>比赛时间安排 </strong></p><p style="text-indent: 32pt;"><span style="font-family: 仿宋;">1. 第一阶段：比赛启动、宣传</span><span style="color: rgb(0, 0, 0); font-family: 仿宋;">（2023年11-12月）； </span></p><p style="text-indent: 32pt;"><span style="color: rgb(0, 0, 0); font-family: 仿宋;">2. 第二阶段：比赛作品征集（2024年1-5月）；</span></p><p style="text-indent: 32pt;"><span style="color: rgb(0, 0, 0); font-family: 仿宋;">3. 第三阶段：作品评审、获奖证书发放（2024年6月）； &nbsp; &nbsp;</span></p><p style="text-indent: 32pt;"><span style="color: rgb(0, 0, 0); font-family: 仿宋;">4. 第四阶段：总结颁奖、优秀作品结集出版、“艺朵·美空间”展演、美育理论与实践研修、线下展览等活动（2024年7-12月）。</span></p><p style="text-indent: 32pt;"><span style="color: rgb(0, 0, 0); font-family: 黑体;">六、</span><strong>具体要求</strong></p><p style="text-indent: 32.25pt;"><strong>（一）创作要求</strong></p><p style="text-indent: 32pt;"><span style="color: rgb(0, 0, 0); font-family: 仿宋;">1.以“我的梦想”为主题进行创作。</span></p><p style="text-indent: 32pt; text-align: justify;"><span style="color: rgb(0, 0, 0); font-family: 仿宋;">表达参赛学生的童年梦想，对建设美丽家乡、创造幸福生活、共筑人类美好未来的憧憬。表达参赛学生的未来理想，把爱家和爱国统一起来，把实现个人梦融入国家梦、民族梦之中。倡导根植于中华优秀传统文化沃土，挖掘和传承具有民族特色、地域特点的优秀传统文化，充分展现作者对于美的感受力、想象力、创造力。</span></p><p style="text-indent: 32pt;"><span style="font-family: 仿宋;">2.须与参赛作品同步提交不少于100字创作思路。</span></p><p style="text-indent: 32pt;"><span style="font-family: 仿宋;">3.集体参赛作品须提交全部参赛学生信息。</span></p><p style="text-indent: 32pt;"><span style="font-family: 仿宋;">4.鼓励参赛学生提交参赛作品的创作过程视频资料。</span></p><p style="text-indent: 32.15pt;"><strong>（二）报名方式</strong></p><p style="text-indent: 32pt;"><span style="font-family: 仿宋;">报名方式分为集体报名和个人报名；严禁跨省参赛。</span></p><p style="text-indent: 24pt;"><span style="font-family: 仿宋;">1.集体报名</span></p><p style="text-indent: 32pt;"><span style="font-family: 仿宋;">通过赛区组委会报名参赛。</span></p><p style="text-indent: 32pt;"><span style="font-family: 仿宋;">2.个人报名</span></p><p style="text-indent: 32pt;"><span style="font-family: 仿宋;">通过微信公众号</span><u><strong>（中小学生摄影比赛）</strong></u><span style="font-family: 仿宋;">，注册为“全国中小学生竞赛展演活动智慧管理平台”用户后报名参赛。</span></p><p style="text-indent: 32.15pt;"><strong>（三）规格要求</strong></p><p style="text-indent: 32pt;"><span style="font-family: 仿宋;">手机摄影作品、专业摄影作品、</span><u><strong>小天才电话手表</strong></u><span style="font-family: 仿宋;">摄影都可参与本赛事，作品附技术介绍（如：拍摄的设备、参数、场景等）</span></p><p style="text-indent: 32.15pt;"><strong>（四）版权说明 </strong></p><p style="text-indent: 32pt;"><span style="font-family: 仿宋;">1.参赛作品须为本赛季内创作完成的原创作品；</span></p><p style="text-indent: 32pt;"><span style="font-family: 仿宋;">2.参赛作品不得侵犯他人隐私权等第三方权利，参赛作品若产生法律纠纷，由参赛学生及其监护人全部承担；</span></p><p style="text-indent: 32pt;"><span style="font-family: 仿宋;">3.参赛学生及其监护人不得要求主办单位退还参赛作品原件，参赛作品所有权归主办单位所有；主办单位有权在公益活动中使用参赛作品（包括但不限于展出、宣传、出版、制作衍生品等），无需支付稿酬；参赛学生享有参赛作品署名权。 </span></p><p style="text-indent: 32.15pt;"><strong>（五）评选方式</strong></p><p style="text-indent: 32pt;"><span style="font-family: 仿宋;">1.评审原则 </span></p><p style="text-indent: 32pt;"><span style="font-family: 仿宋;">秉承公平、公正、公开的评审原则。</span></p><p style="text-indent: 32pt;"><span style="font-family: 仿宋;">未正确理解主题，作品包含违法内容、政治属性标识错误的参赛作品为无效参赛作品，不予评审。 </span></p><p style="text-indent: 32pt;"><span style="font-family: 仿宋;">2.评审形式 </span></p><p style="text-indent: 32pt;"><span style="font-family: 仿宋;">（1）初评：赛区组委会组建初评专家组，根据评审规则，评审本赛区参赛作品。评审结果报比赛组委会。</span></p><p style="text-indent: 32pt;"><span style="font-family: 仿宋;">（2）复评：比赛组委会专家评审委员，根据评审规则对初评结果进行复核，点评部分优秀作品。</span></p><p><span style="font-family: 仿宋;"> &nbsp; </span><strong>（六）奖励办法</strong></p><p style="text-indent: 32pt;"><span style="font-family: 仿宋;">1.学生奖项设置 </span></p><p style="text-indent: 32pt;"><span style="font-family: 仿宋;">类别：摄影</span></p><p style="text-indent: 32pt;"><span style="font-family: 仿宋;">奖项：一等奖、二等奖、三等奖三个奖项。 </span></p><p style="text-indent: 32pt;"><span style="font-family: 仿宋;">2.组织单位及指导教师奖项设置 </span></p><p style="text-indent: 32pt;"><span style="font-family: 仿宋;">类别：优秀组织单位奖、优秀指导教师奖。</span></p><p style="text-indent: 32pt;"><span style="font-family: 仿宋;">3.证书查询</span></p><p style="text-indent: 32pt;"><span style="font-family: 仿宋;">登录微信公众号（学与玩杂志）或中国儿童网查询获奖结果，下载电子版证书。电子版证书包含获奖证书和参赛学生的</span><span style="color: rgb(0, 0, 0); font-family: 仿宋;">《社会实践证明》</span><span style="font-family: 仿宋;">。</span></p><p style="text-indent: 32pt;"><span style="font-family: 仿宋;">4. 证书申领</span></p><p style="text-indent: 32pt;"><span style="font-family: 仿宋;">小天才电话手表赛道获奖的选手，申领的纸质证书将以快递形式送至指定地点。纸质证书与电子版证书编号一致，同等作用于证明参赛结果。</span></p><p style="text-indent: 32pt;"><span style="font-family: 黑体;">七、联系方式</span></p><p style="text-indent: 32pt;"><span style="font-family: 仿宋;">地址：北京市石景山区鲁谷路136号紫玉时代中心803</span></p><p style="text-indent: 32pt;"><span style="font-family: 仿宋;">邮编：100035 </span></p><p style="text-indent: 32pt;"><span style="font-family: 仿宋;">联系人：肖老师</span></p><p style="text-indent: 32pt;"><span style="font-family: 仿宋;">咨询电话：010-53352288、13720000289</span></p><p style="text-indent: 32pt;"><br></p><p><br></p>`,
    };
  },
  mounted() {
    this.TENANTID = localStorageGetItem("TENANT-ID") || "0";
    this.role = this.$store.state.role;
    if (this.$route.query.activityId != undefined) {
      this.getDetail();
      return;
    }
    const infos = JSON.parse(window.localStorage.getItem("active_infos_data"));
    if (!infos) {
      this.$router.replace("/");
    }
    this.pushData(infos);
  },
  beforeRouteLeave(to, from, next) {
    //   if (to.name == "Login" && this.activityId)
    if (to.name == "Login") {
      next({ name: "HomeIndex" });
    } else {
      next();
    }
  },
  methods: {
    showUnit() {
      this.unitShow = true;
    },
    tagetFn(fnName) {
      this[fnName]();
    },
    pushData(infos) {
      this.intro = infos.synopsis;
      this.name = infos.name;
      this.poster = infos.posterUrl;
      this.type = infos.typeId;
      if (infos.model == 1) {
        this.infosList.push(
          {
            ico: require("../../assets/images/home/act-txt-ico1.png"),
            txt: `投稿时间：${infos.startTime} 至 ${infos.endTime}`
          },
          {
            ico: require("../../assets/images/home/act-txt-ico2.png"),
            txt: `点评时间：${infos.startAuditTime} 至 ${infos.endAuditTime}`
          }
          // {
          //   txt: "赛事组织单位",
          //   lnkFn: "showUnit"
          // }
        );
      } else {
        if (infos.id == 24) {
          this.infosList.push(
            {
              ico: require("../../assets/images/home/act-txt-ico1.png"),
              txt: `投稿时间：2023-02-22 00:00:00 至 2023-08-10 23:59:59`
            },
            {
              ico: require("../../assets/images/home/act-txt-ico2.png"),
              txt: `初评时间：2023-05-01 00:00:00 至 2023-08-12 23:59:59`
            },
            {
              ico: require("../../assets/images/home/act-txt-ico3.png"),
              txt: `终评时间：2023-08-03 00:00:00 至 2023-08-20 23:59:59`
            }
            // {
            //   txt: "赛事组织单位",
            //   lnkFn: "showUnit"
            // }
          );
        } else {
          this.infosList.push(
            {
              ico: require("../../assets/images/home/act-txt-ico1.png"),
              txt: `投稿时间：${infos.startTime} 至 ${infos.endTime}`
            },
            {
              ico: require("../../assets/images/home/act-txt-ico2.png"),
              txt: `初评时间：${infos.startAuditTime} 至 ${infos.endAuditTime}`
            },
            {
              ico: require("../../assets/images/home/act-txt-ico3.png"),
              txt: `终评时间：${infos.startFinishTime} 至 ${infos.endFinishTime}`
            }
            // {
            //   txt: "赛事组织单位",
            //   lnkFn: "showUnit"
            // }
          );
        }

        // ------------------
      }
    },
    getDetail() {
      activityDetail(this.activityId).then((res) => {
        if (res.success) {
          var infos = res.data;
          this.pushData(infos);
          window.localStorage.setItem(
            "active_infos_data",
            JSON.stringify(infos)
          );
        }
      });
    },
    toApplyPage() {
      if (this.type == 1) this.$root.$toast.fail("报名已结束");
      else if (this.type == 2) this.$root.$toast.fail("报名未开始");
      // else this.$router.replace("/home/apply");
      else {
        this.$router.replace("/home/activityapply");
      }
    },
    /**
     * @description: 跳转赛务查询页面
     * @author: wangxiaoheng
     */
    getaffairsQuery() {
      this.$router.replace("/home/affairsQuery");
    }
  }
};
</script>

<style lang="scss" scoped>
.activity {
  padding-bottom: 100px;
  .banner {
    width: 100%;
    max-width: 10rem;
    position: relative;
    overflow: hidden;
    padding-bottom: 10px;
    .banner-img {
      width: 100%;
      height: 160px;
      position: absolute;
      z-index: 0;
      top: 0;
      left: 0;
    }
    .banner-content {
      position: relative;
      margin: 0 auto;
      width: 100%;
      margin-top: 103px;
      z-index: 5;
      padding: 0 12px;
      min-height: 175px;
      width: 335px;
      background-color: #fff;
      border-radius: 8px;
      overflow: hidden;
      padding-bottom: 10px;
      box-shadow: 0px 2px 5px rgba(5, 75, 27, 0.2);
      h2 {
        min-height: 28px;
        line-height: 28px;
        color: #000;
        margin: 0;
        margin-top: 12px;
        font-weight: 900;
        font-size: 20px;
      }
      .act-infos {
        margin-top: 4px;
        .status {
          font-size: 12px;
          line-height: 16px;
          height: 16px;
          background-color: #6cdd8f;
          color: #fff;
          text-align: center;
          border-radius: 0 8px 0 8px;
          width: 46px;
          &.end {
            background-color: #eee;
          }
          &.red {
            background-color: red;
          }
        }
        .act-infos-lst {
          .lst-item {
            display: flex;
            line-height: 30px;
            font-size: 12px;
            color: #999999;
            align-items: center;
            height: 30px;
            p {
              font-size: 20px;
              transform: scale(0.5) translateX(-50%);
              min-width: 588px;
              text-align: left;
            }
            &.link {
              font-size: 14px;
              color: #5eaaff;
              line-height: 14px;
              height: 14px;
              p {
                font-size: 12px;
                transform: scale(1);
                min-width: 294px;
                text-align: left;
              }
            }
            img {
              margin-right: 3px;
              width: 16px;
              width: 16px;
            }
          }
        }
      }
    }
  }
  .act-attention {
    background-color: #fff;
    padding: 0 20px;
    text-align: left;
    margin-bottom: 80px;
    .act-intro {
      line-height: 22px;
      font-size: 14px;
      color: #999;
    }
    .act-intro2 {
      line-height: 22px;
      font-size: 14px;
    }
  }
  .unit-lst-wrap {
    height: 100%;
    overflow-y: scroll;
    margin: 60px 0;
    padding: 0 36px;
  }
  .unit-lst {
    line-height: 22px;
    font-size: 14px;
    color: #999;
    text-align: left;
    padding-bottom: 100px;
  }
  .contribute {
    text-align: center;
    color: #16d77a;
    background-color: unset;
    position: fixed;
    bottom: 50px;
    display: flex;
    width: 100%;
    justify-content: center;
    .van-button {
      border-radius: 16px;
      width: 254px;
      height: 32px;
      box-shadow: 0 10px 10px #0002;
    }
  }
}
.affairsQuery {
  position: fixed;
  width: 94px;
  height: 46px;
  right: 0;
  top: 340px;
}
</style>
<style lang="scss">
.activity {
  .van-popup {
    border-radius: 20px 20px 0 0;
    overflow-y: hidden;
    .van-icon {
      right: calc((100% - 16px) / 2);
      font-size: 16px;
      &::after {
        content: "";
        position: absolute;
        left: -3px;
        top: -3px;
        height: 20px;
        width: 20px;
        box-sizing: content-box;
        border: 1px solid #c8c9cc;
        border-radius: 50%;
      }
    }
  }
}
</style>
